{
  "auth.login.otp.email.back.button_label": "Retour",
  "auth.login.otp.email.cancel.button_label": "Annuler",
  "auth.login.otp.email.continue.button_label": "Continuer",
  "auth.login.otp.email.error_format": "Veuillez saisir une adresse email valide",
  "auth.login.otp.email.forgot_password.link_text": "Mot de passe oublié ? Connectez-vous avec un code d’accès",
  "auth.login.otp.email.form.label": "Email",
  "auth.login.otp.email.form.placeholder": "Email",
  "auth.login.otp.email.passcode.form.helper_text": "Saisissez le code envoyé à",
  "auth.login.otp.email.passcode.form.label": "Code",
  "auth.login.otp.email.passcode.form.placeholder": "Code",
  "auth.login.otp.email.passcode.helper_text": "Nous vous enverrons un code pour confirmer votre adresse email.",
  "auth.login.otp.email.passcode.resend.link_text": "Vous n’avez pas reçu notre email ? Renvoyer le code",
  "auth.login.otp.email.passcode.resend.link_text.resending": "Renvoi en cours...",
  "auth.login.otp.email.passcode.switch_method.link_text": "Envoyer le code au numéro de téléphone",
  "auth.login.otp.email.password.label": "Mot de passe",
  "auth.login.otp.email.password.placeholder": "Mot de passe",
  "auth.login.otp.email.password.required": "Mot de passe requis"
}
